import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import PropTypes from 'prop-types';
import PayParcelForm from './PayParcelForm';
import Modal from '../../../common/modal/Modal';
import {
  getActiveSalesSession,
  getParcel,
  putParcelToPay,
} from '../../../../actions';
import { CARGO_PATH } from '../../../../config/paths';
import {
  buildTransactionList,
  flagUsedPinpadTransactions,
  summarizeSplit,
} from '../../../../utils/units/paymentSplit';

const isDefined = (value) => value !== null && value !== undefined;

const getParcelPendingAmount = (parcel) =>
  parcel.salePriceWithDiscount || parcel.salePrice || 0;

const PayParcelButton = ({
  parcel,
  dispatchPutParcelPay,
  dispatchGetParcel,
  dispatchGetActiveSalesSession,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');

  const pendingAmount = getParcelPendingAmount(parcel);

  const onModalSubmit = async (formValues) => {
    const transactionList = formValues.transactionList || [];

    const summary = summarizeSplit(transactionList, pendingAmount);

    if (summary.hasDuplicateMethods) {
      toastr.error(
        'Error',
        'No puede repetir el mismo método de pago en dos filas',
      );
      return;
    }

    if (!summary.isValid) {
      toastr.error(
        'Error',
        summary.isPending
          ? 'Los montos no cubren el monto pendiente'
          : 'Los montos superan el monto pendiente',
      );
      return;
    }

    const { transactions } = buildTransactionList(transactionList, {
      totalPrice: pendingAmount,
      customerId: parcel.customer ? parcel.customer.id : null,
      voucherTypeId: isDefined(parcel.voucherTypeId)
        ? parcel.voucherTypeId
        : null,
      businessId: parcel.business ? parcel.business.id : null,
    });

    const isParcelPay = await dispatchPutParcelPay({
      parcelId: parcel.id,
      transactionList: transactions,
      pinPadTransactions: flagUsedPinpadTransactions(
        formValues.pinPadTransactions || [],
        transactionList,
      ),
    });

    if (isParcelPay) {
      dispatchGetParcel({ parcelId: parcel.id });
      setModalBody(null);
    }
  };

  const openModal = async () => {
    await dispatchGetActiveSalesSession({
      source: `${CARGO_PATH}/${parcel.id}`,
    });
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const buildModalBody = () => {
    const newModalBody = (
      <PayParcelForm
        parcel={parcel}
        pendingAmount={pendingAmount}
        onCancel={closeModal}
        handleProcess={onModalSubmit}
      />
    );
    setModalBody(newModalBody);
  };

  useEffect(() => {
    if (showModal !== false) {
      buildModalBody();
    }
  }, [showModal]);

  return (
    <>
      <Modal
        show={showModal}
        title="Pagar Encomienda"
        body={modalBody}
        size="lg"
      />
      <Button color="info" onClick={openModal}>
        <i className="fa  fa-money" /> Pagar
      </Button>
    </>
  );
};

PayParcelButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  parcel: PropTypes.object.isRequired,
  dispatchPutParcelPay: PropTypes.func.isRequired,
  dispatchGetParcel: PropTypes.func.isRequired,
  dispatchGetActiveSalesSession: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPutParcelPay: putParcelToPay,
  dispatchGetParcel: getParcel,
  dispatchGetActiveSalesSession: getActiveSalesSession,
};

export default connect(null, mapDispatchToProps)(PayParcelButton);
